<template>
  <div class="root-content">
    <slot />
  </div>
</template>
<script>
export default {
  name: "RootContent",
  props: {},
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/size";

.root-content {
  position: relative;
  height: 100%;
  max-width: 1240px;
  top: 56px;
  padding: 24px 24px 100px 24px;
  margin: 0 auto;

  @media (max-width: $min_layout) {
    padding: 24px 16px 100px 16px;
    margin: 0;
  }
}
</style>
